module.exports = __webpack_public_path__ + "img/leaves2.baa0c3f7.png";